import { setContext } from '@apollo/client/link/context'
import { getHeaders } from '@babylon/headers'
import config from '@/config'
import { authTokenStorageKey } from '@/constants'

const { VERSION } = config

export default (appName: string, acceptLanguage: string) =>
  setContext(() => {
    const token = sessionStorage.getItem(authTokenStorageKey)

    return {
      headers: {
        ...getHeaders({
          acceptLanguage,
          appId: appName,
          appVersion: VERSION,
        }),
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    }
  })
